/**
 * Tipos de canal de forma de pagamento (mesma lista do formulário admin).
 * Manter em sincronia com a API / regras de negócio.
 */
export const TIPO_OPCOES = [
  { group: "Outros", label: "Default (manual)", value: 0 },
  { group: "Outros", label: "Dinheiro (no balcão)", value: 5 },

  { group: "Pix", label: "Pix — Itaú", value: 8 },
  { group: "Pix", label: "Pix — Cielo", value: 15 },
  { group: "Pix", label: "Pix — Buspay", value: 1 },

  { group: "Cartão", label: "Cartão de crédito — Rede", value: 9 },
  { group: "Cartão", label: "Cartão de crédito — Cielo", value: 14 },
  { group: "Cartão", label: "Cartão de crédito — Pagar.me", value: 2 },
  { group: "Cartão", label: "Cartão de crédito — Adyen", value: 10 },
  { group: "Cartão", label: "Cartão de crédito — Pague Fácil", value: 4 },

  { group: "Link / Checkout", label: "Cielo — Checkout (link de pagamento)", value: 3 },
  { group: "Link / Checkout", label: "Mercado Pago — Checkout (link de pagamento)", value: 6 },
  { group: "Link / Checkout", label: "Xpay — Checkout (link de pagamento)", value: 7 },
  { group: "Link / Checkout", label: "AppMax — Checkout (link)", value: 11 },

  { group: "AppMax (API)", label: "Pix — AppMax", value: 12 },
  { group: "AppMax (API)", label: "Cartão de crédito — AppMax", value: 13 },
];

const labelByTipo = new Map(TIPO_OPCOES.map((o) => [o.value, o.label]));

/** Tipos que representam Pix (manter alinhado à API / grupo Pix no admin). */
export const PIX_PAYMENT_TIPOS = new Set(
  TIPO_OPCOES.filter((o) => o.group === "Pix" || String(o.label).startsWith("Pix —")).map(
    (o) => o.value
  )
);

export function isPixPaymentTipo(tipo) {
  const n = Number(tipo);
  return Number.isFinite(n) && PIX_PAYMENT_TIPOS.has(n);
}

/** Rótulo do tipo de canal para listagens (tabela, exports, etc.) */
export function getPaymentMethodTipoLabel(t) {
  const n = Number(t);
  if (!Number.isFinite(n)) return "—";
  return labelByTipo.get(n) ?? `Tipo #${n}`;
}
